module.exports = __webpack_public_path__ + "static/media/template_user.728876d2.csv";